import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromError from './error.reducer';
import { ErrorEffects } from './error.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(fromError.errorFeatureKey, fromError.reducers, {
            metaReducers: fromError.metaReducers,
        }),
        EffectsModule.forFeature([ErrorEffects]),
    ],
})
export class ErrorModule {}

export * as ErrorActions from './error.actions';
export * as ErrorSelectors from './error.selectors';
